import React from 'react';
import ComingSoon from './ComingSoon';

// This page used to show hard-coded sample campaigns and send counts. Nothing
// here sent anything, so it is labelled rather than left looking live.
export default function MarketingPage() {
  return (
    <ComingSoon
      title="Marketing"
      note="Email/SMS campaigns are not available yet. Customer reminders and review requests are set up under Settings → Automations."
    />
  );
}
